// Salle socket de l'utilisateur (ses notifications : demandes de cours, acceptation, fin de
// cours…) rejointe à chaque connexion du socket, y compris après une reconnexion
// automatique (coupure réseau, mise en veille, redémarrage du serveur, onglet en
// arrière-plan dont la connexion a été coupée). Avant, elle n'était rejointe qu'au
// chargement de la page : après une reconnexion, plus aucune notification n'arrivait.
// Le serveur vérifie le jeton et renvoie les demandes de cours encore en attente.
// Renvoie la fonction qui arrête de suivre les connexions.
export const keepUserRoomJoined = (socket, getToken) => {
  const join = () => {
    const token = getToken();
    if (token) socket.emit("joinRoom", { token });
  };
  if (socket.connected) join();
  socket.on("connect", join);
  return () => socket.off("connect", join);
};

// Demande de cours déjà affichée (le serveur renvoie les demandes en attente à chaque
// reconnexion) : true la première fois seulement pour un même cours
export const createRequestDeduper = () => {
  const seen = new Set();
  return (classId) => {
    if (!classId) return true;
    if (seen.has(String(classId))) return false;
    seen.add(String(classId));
    return true;
  };
};
